export default __webpack_public_path__ + "static/media/Comparison.3a3dc37e.svg";